import React from 'react';
import { useBoolean } from 'react-hanger';
import cls from 'classnames';

import Styled from './styled';
import { ItemProps } from '../types';

const Toggle = (
  props: ItemProps & {
    trueValue?: any;
    falseValue?: any;
  },
) => {
  const {
    className,
    label,
    name,
    value,
    onChange,
    trueValue = true,
    falseValue = false,
  } = props;

  const getBoolValue = (target) => {
    return target === trueValue;
  };

  const getRealValue = (target) => {
    return target ? trueValue : falseValue;
  };

  const boolValue = getBoolValue(value);

  const isOn = useBoolean(boolValue);

  const handleChange = () => {
    const nextOn = !isOn.value;
    isOn.setValue(nextOn);
    onChange(name, getRealValue(nextOn));
  };

  return (
    <Styled.Toggle className={cls('form-item form-item-toggle', className)}>
      {label && <label className="form-item-label">{label}</label>}
      <div
        onClick={handleChange}
        className={cls('form-item-input', { on: boolValue })}
      />
    </Styled.Toggle>
  );
};

export default Toggle;
